import {
  DialogFooter as DialogFooterBase,
  type DialogFooterProps,
} from "@src/appV2/redesign/system/ui-components";

import { ButtonInternalLink } from "./ButtonInternalLink";

export function DialogFooter(props: Omit<DialogFooterProps, "LinkComponent">) {
  return <DialogFooterBase {...props} LinkComponent={ButtonInternalLink} />;
}
